module.exports = __webpack_public_path__ + "assets/ribao.39e369e7f8ad4c3dde17e37783394e49.png";